import React from 'react';
import {
  DetailHeader,
  ReturnToList,
  ReturnToListContainer,
  HeaderItemContainer,
  ColumnItem,
  HeaderItem,
  SecondReceiptLabel,
  Item,
  ReceiptStatus,
  HistoryText,
} from './styles';
import { ArrowBack } from '@mui/icons-material';
import moment from 'moment';
import { CheckCircle, HighlightOff } from '@mui/icons-material';
import { imageStatus } from '../../Receipts';
import { USER_TYPES } from '../../../../../Admin/shared/static-options';

const ReceiptDetailHeader = ({
  onReturnToList,
  goToHistory,
  selectedReceiptType,
  date,
  format,
  size,
  status,
  history,
  userType
}) => {
  const notAvailable = 'Indisponível';
  
  return (
    <DetailHeader>
      <HeaderItemContainer>
        <ReturnToListContainer>
          <ColumnItem>
            <ReturnToList onClick={() => onReturnToList()}>
              <ArrowBack />
              Voltar para a lista
            </ReturnToList>
            <SecondReceiptLabel>
              {selectedReceiptType ?? notAvailable}
            </SecondReceiptLabel>
          </ColumnItem>
        </ReturnToListContainer>
        <ColumnItem>
          <HeaderItem>Data de upload</HeaderItem>
          <Item>
            {date ? moment(date).format('DD/MM/YYYY • HH:mm') : notAvailable}
          </Item>
        </ColumnItem>
        <ColumnItem>
          <HeaderItem>Formato</HeaderItem>
          <Item>{format ?? notAvailable}</Item>
        </ColumnItem>
        <ColumnItem>
          <HeaderItem>Tamanho</HeaderItem>
          <Item>{size ?? notAvailable}</Item>
        </ColumnItem>
        <ColumnItem>
          <HeaderItem>Status</HeaderItem>
          {status === imageStatus.ACTIVE ? (
            <ReceiptStatus>
              <CheckCircle color="success" sx={{ fontSize: 16 }} />
              Ativo
            </ReceiptStatus>
          ) : (
            <ReceiptStatus>
              <HighlightOff sx={{ fontSize: 16 }} />
              Inativo
            </ReceiptStatus>
          )}
        </ColumnItem>
        {userType === USER_TYPES.CUSTOMER_SERVICE_USER && (
          <ColumnItem>
            <HeaderItem>Histórico</HeaderItem>
            <HistoryText 
              onClick={() => goToHistory()}
            >
              {history ?? notAvailable}
            </HistoryText>
          </ColumnItem>
        )}
      </HeaderItemContainer>
    </DetailHeader>
  );
};
export default ReceiptDetailHeader;
